const STATUSES = {
    Active: {
        label: "Active",
        actions: ['View', 'Create New version'],
        transitions: ['Unpublish']
    },
    Inactive: {
        label: "Inactive",
        actions: ['View'],
        transitions: ['Make as Draft', 'Archive']
    },
    Archived: {
        label: "Archived",
        actions: [],
        transitions: []
    },
    Draft: {
        label: "Draft",
        actions: ['View', 'Edit', 'Delete'],
        transitions: ['On Hold', 'Send for Approval']
    },
    "In Review": {
        label: "In Review",
        actions: ['View'],
        transitions: ['Approve', 'Reject']
    },
    Approved: {
        label: "Approved",
        actions: ['View'],
        transitions: ['Make as Draft', 'Publish']
    },
    Rejected: {
        label: "Rejected",
        actions: ['View'],
        transitions: ['Make as Draft', 'Make as Hold']
    },
    "On Hold": {
        label: "On Hold",
        actions: ['View', 'Delete'],
        transitions: ['Make As Draft']
    },
};

const APPLICATIONS = { Intelliread: "Intelliread", Legacy: "Legacy" };

const TYPES = { Standard: "Standard", "Fast Forward": "Fast Forward" };

const CATEGORIES = {
    "Training Program": "Training Program",
    Event: "Event",
    Webinar: "Webinar",
};

const LOCATIONS = {
    Online: "Online",
    "In-Person": "In-Person",
    External: "External",
};

const MODES = {
    TIMED: "Timed",
    FLEXIBLE: "Flexible",
    FIXED: "Fixed",
};

const APPROVAL_STATUSES = {
    Pending: "Pending",
    Approved: "Approved",
};

const APPROVAL = {
    0: "Not approved",
    1: "Approved",
    null: "Not responded",
};

const PREREQUISITE_TYPES = {
    Preferred: "Preferred",
    Mandatory: "Mandatory",
};


const CATEGORY = {
    Diagnostic: "Diagnostic",
    Course: "Course",
}


const SECTION_TYPE = {
    Story: "Story",
    Course: "Course",
}

const STUDENT_TYPE = {
    URBAN: "Urban",
    RURAL: "Rural",
};


export const course = {
    STATUSES,
    APPLICATIONS,
    TYPES,
    CATEGORIES,
    LOCATIONS,
    MODES,
    APPROVAL_STATUSES,
    APPROVAL,
    PREREQUISITE_TYPES,
    CATEGORY,
    SECTION_TYPE,
    STUDENT_TYPE,
};

export const lessonPlan = {
    STATUSES: {
        INACTIVE: 'Inactive',
        ARCHIVED: 'Archived',
        DRAFT: 'Draft',
        ON_HOLD: 'On Hold',
        ACTIVE: 'Active'
    }
} 